import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["value", "onChange", "onBlur", "asyncValidate"];
import React from 'react';
import { getLanguage } from '@citrite/translate';
import { numberWithDecimalStyle, unformatNumber } from '@csg/g11n-sdk-core';
import { Field, getId } from '../Field/Field';
import { textInputWidth } from '../Field/Field.styled';
import { withTranslate } from '../util';
import { NUMBER_INPUT_MAX_LENGTH } from './NumberInput';
import { TextInput } from './TextInput';
export function FormattedNumberField(props) {
  var id = getId(props);
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    htmlFor: id
  }), /*#__PURE__*/React.createElement(FormattedNumberInput, _extends({
    maxWidth: textInputWidth
  }, props, {
    id: id
  })));
}
var _FormattedNumberInput = /*#__PURE__*/function (_React$Component) {
  function _FormattedNumberInput() {
    var _this;
    _classCallCheck(this, _FormattedNumberInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, _FormattedNumberInput, [].concat(args));
    _defineProperty(_this, "state", {
      errorMsg: '',
      value: !isNaN(_this.props.value) ? numberWithDecimalStyle(_this.props.value, getLanguage(), {
        maximumFractionDigits: _this.props.decimalPlaces
      }) : undefined
    });
    _defineProperty(_this, "onChange", function (value) {
      var unformattedValue = unformatNumber(value, getLanguage());
      var number = parseFloat(unformattedValue);
      if (unformattedValue.length === 1 && unformattedValue === '-') {
        _this.setState({
          errorMsg: _this.getErrorMsg(number),
          value: value
        });
        return;
      }
      if (_this.isValidInput(unformattedValue) || !unformattedValue) {
        var errorMsg = value && _this.getErrorMsg(number);
        _this.props.onChange(isNaN(number) ? undefined : number);
        _this.props.onErrorChange && _this.props.onErrorChange(errorMsg);
        _this.setState({
          errorMsg: errorMsg,
          value: value
        });
      }
    });
    _defineProperty(_this, "getErrorMsg", function (number) {
      var errorMessage;
      if (isNaN(number)) {
        errorMessage = _this.props.t('citrix-ui:validation.formattedNumberField.notNumber');
      } else if (typeof _this.props.max === 'number' && typeof _this.props.min === 'number') {
        if (_this.props.max === _this.props.min) {
          errorMessage = _this.notEqualError(number);
        } else {
          errorMessage = _this.props.not ? _this.notBetweenError(number) : _this.betweenError(number);
        }
      } else if (typeof _this.props.max === 'number') {
        errorMessage = _this.props.maxInclusive ? _this.lessEqualError(number) : _this.lessError(number);
      } else if (typeof _this.props.min === 'number') {
        errorMessage = _this.props.minInclusive ? _this.greaterEqualError(number) : _this.greaterError(number);
      }
      return errorMessage || '';
    });
    _defineProperty(_this, "notEqualError", function (number) {
      if (number === _this.props.max) {
        return _this.props.t('citrix-ui:validation.formattedNumberField.cannotBeEqualError', {
          number: _this.props.max
        });
      }
    });
    _defineProperty(_this, "notBetweenError", function (number) {
      if (number > _this.props.min && number < _this.props.max) {
        return _this.props.t('citrix-ui:validation.formattedNumberField.cannotBeBetweenError', {
          min: _this.props.min,
          max: _this.props.max
        });
      }
    });
    _defineProperty(_this, "betweenError", function (number) {
      if (number <= _this.props.min || number >= _this.props.max) {
        return _this.props.t('citrix-ui:validation.formattedNumberField.mustBeBetweenError', {
          min: _this.props.min,
          max: _this.props.max
        });
      }
    });
    _defineProperty(_this, "lessEqualError", function (number) {
      if (number > _this.props.max) {
        return _this.props.t('citrix-ui:validation.formattedNumberField.mustBeLessEqualError', {
          number: _this.props.max
        });
      }
    });
    _defineProperty(_this, "lessError", function (number) {
      if (number >= _this.props.max) {
        return _this.props.t('citrix-ui:validation.formattedNumberField.mustBeLessError', {
          number: _this.props.max
        });
      }
    });
    _defineProperty(_this, "greaterEqualError", function (number) {
      if (number < _this.props.min) {
        return _this.props.t('citrix-ui:validation.formattedNumberField.mustBeGreaterEqualError', {
          number: _this.props.min
        });
      }
    });
    _defineProperty(_this, "greaterError", function (number) {
      if (number <= _this.props.min) {
        return _this.props.t('citrix-ui:validation.formattedNumberField.mustBeGreaterError', {
          number: _this.props.min
        });
      }
    });
    return _this;
  }
  _inherits(_FormattedNumberInput, _React$Component);
  return _createClass(_FormattedNumberInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        var formattedNumber = !isNaN(this.props.value) && numberWithDecimalStyle(this.props.value, getLanguage(), {
          maximumFractionDigits: this.props.decimalPlaces
        });
        if (formattedNumber.length > this.props.maxLength) {
          this.setState(function (_, props) {
            return {
              value: undefined,
              errorMsg: props.t('citrix-ui:validation.formattedNumberField.overCharLimitError')
            };
          });
        } else {
          this.setState({
            value: formattedNumber
          });
        }
      }
    }
  }, {
    key: "isValidInput",
    value: function isValidInput(value) {
      var number = parseFloat(value);
      if (this.props.preventNegative && (isNaN(number) || number < 0)) {
        return false;
      }
      if (this.props.decimalPlaces > 0) {
        return value.match("^[-]?([0-9])*([.]?[0-9]{0,".concat(this.props.decimalPlaces, "})?$"));
      }
      return value.match('^[-]?[0-9]*$');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        onChange = _this$props.onChange,
        onBlur = _this$props.onBlur,
        asyncValidate = _this$props.asyncValidate,
        other = _objectWithoutProperties(_this$props, _excluded);
      return /*#__PURE__*/React.createElement(TextInput, _extends({}, other, {
        onChange: this.onChange,
        value: this.state.value,
        errorMessage: this.state.errorMsg,
        maxLength: this.props.maxLength,
        validateOnChange: true,
        showCharacterLimit: true
      }));
    }
  }]);
}(React.Component);
_defineProperty(_FormattedNumberInput, "defaultProps", {
  maxLength: NUMBER_INPUT_MAX_LENGTH,
  decimalPlaces: 0
});
export var FormattedNumberInput = withTranslate(_FormattedNumberInput);